import React from 'react'
import {Icon} from '@chakra-ui/react'

const DownloadIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <circle cx="20" cy="20" r="20" />
            <path
                d="M30.3963 23.3C30.0063 22.91 29.3763 22.92 28.9863 23.3L20.8363 31.55V6C20.8363 5.45 20.3863 5 19.8363 5C19.2863 5 18.8363 5.45 18.8363 6V31.55L10.7063 23.31C10.3163 22.92 9.68626 22.91 9.29626 23.31C8.90626 23.7 8.89626 24.33 9.29626 24.72L19.1063 34.66C19.1063 34.66 19.1263 34.7 19.1463 34.71C19.1663 34.73 19.2063 34.74 19.2263 34.76C19.2963 34.82 19.3763 34.88 19.4663 34.92C19.5863 34.97 19.7163 35 19.8463 35C20.0963 35 20.3563 34.9 20.5463 34.71C20.5663 34.69 20.5663 34.67 20.5763 34.66L30.3963 24.71C30.7863 24.32 30.7763 23.68 30.3963 23.3Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default DownloadIcon
